function getHttpStatus(error: Error): number | null {
  if ("status" in error && typeof error.status === "number")
    return error.status;
  // tRPC errors expose HTTP status in data, rather than at the top level.
  if (
    "data" in error &&
    typeof error.data === "object" &&
    error.data !== null &&
    "httpStatus" in error.data &&
    typeof error.data.httpStatus === "number"
  )
    return error.data.httpStatus;
  return null;
}

export function shouldRetryQuery(failureCount: number, error: Error): boolean {
  const status = getHttpStatus(error);
  if (status !== null && status >= 400 && status < 500) return false;
  return failureCount < 3;
}
